import { render, staticRenderFns } from "./ExternalApiConfig.vue?vue&type=template&id=af200c82&"
import script from "./ExternalApiConfig.vue?vue&type=script&lang=js&"
export * from "./ExternalApiConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af200c82')) {
      api.createRecord('af200c82', component.options)
    } else {
      api.reload('af200c82', component.options)
    }
    module.hot.accept("./ExternalApiConfig.vue?vue&type=template&id=af200c82&", function () {
      api.rerender('af200c82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ExternalApiConfig/ExternalApiConfig.vue"
export default component.exports